import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LevelPage from './LevelPage';
import TeacherDashboard from './TeacherDashboard';

export default function UnifiedLevelPage() {
  const { levelCode } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const authData = sessionStorage.getItem('user_auth');
    if (!authData) {
      navigate('/');
      return;
    }

    const { user } = JSON.parse(authData);
    setUserData(user);
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="flex flex-col items-center gap-6 animate-fade-in">
          <div className="w-16 h-16 loading-spinner"></div>
          <div className="text-center">
            <p className="text-primary-600 font-semibold text-lg">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  // Admin and instructor see TeacherDashboard (editable)
  if (userData?.role === 'admin' || userData?.role === 'instructor') {
    return <TeacherDashboard />;
  }

  // Students see LevelPage (read-only)
  return <LevelPage />;
}
